import {Action} from "@ngrx/store";
import {CacheRules} from "../../websites/website/booster/mappers/cloudflare/cache-rules";

export const LOAD_CACHE_RULES: string = '[redirect] Load Cache Rules Data';
export const LOAD_CACHE_RULES_SUCCESS: string = '[redirect] Load Cache Rules Data Success';
export const LOAD_CACHE_RULES_FAIL: string = '[redirect] Load Cache Rules Data Fail';

export class LoadCacheRules implements Action {
  readonly type: string = LOAD_CACHE_RULES;
  constructor(public payload: number) {}
}

export class LoadCacheRulesSuccess implements Action {

  readonly type: string = LOAD_CACHE_RULES_SUCCESS;
  constructor(public payload: {
    websiteId: number,
    entities: CacheRules,
  }) {}

}

export class LoadCacheRulesFail implements Action {

  readonly type: string = LOAD_CACHE_RULES_FAIL;
  constructor(public payload: string) {}

}


export type CacheRulesAction = LoadCacheRules | LoadCacheRulesSuccess | LoadCacheRulesFail;
